<script lang="ts">
    import CN from "classnames";

    import Button from "@components/Buttons/Button.svelte";
    import Icon from "@components/Icon.svelte";
    import SortIcon from "@components/icons/SortIcon.svelte";

    export let isOpen: boolean;
    export let prefix: string;
    export let currentValue: string;
    export let disabled = false;
</script>

<Button size="large" class="gw-sort-activator" variant="text" {disabled}>
    <span class="gw-sort-activator__current"> {prefix} </span>
    <span class="gw-sort-activator__label-text">
        {currentValue}
    </span>
    <div
        class={CN("gw-sort__icon", {
            "gw-sort__icon-open": isOpen,
        })}
    >
        <Icon>
            <SortIcon />
        </Icon>
    </div>
</Button>
